import Glide from '@glidejs/glide'; // tslint:disable-line
import {Breakpoints} from '@glidejs/glide/dist/glide.modular.esm'; // tslint:disable-line

type Options = Partial<ProductRecentlyViewedOptions>;
export interface ProductRecentlyViewedOptions {
  productHandle?: string;
  glideSelector: string;
  limit: string;
  localStorageKey: string;
  selector: string;
  sliderSettings: object;
}

export class ProductRecentlyViewed {
  static defaults = {
    glideSelector: '.glide',
    limit: '5',
    localStorageKey: 'product-recently-viewed',
    selector: `.product-recently-viewed`,
    sliderSettings: {
      bound: true,
      breakpoints: {
        480: {
          gap: 32,
          perView: 1.75,
        },
        1024: {
          gap: 32,
          perView: 2,
        },
        1280: {
          perView: 4,
        },
      },
      gap: 64,
      perView: 4,
      rewind: false,
      type: 'slider',
    },
  };

  section: HTMLElement | null;
  glide: Glide;
  options: ProductRecentlyViewedOptions;
  productHandles: string[];

  constructor(section: HTMLElement, options: Options = {}) {
    if (!section) {
      return;
    }

    this.options = {
      ...ProductRecentlyViewed.defaults,
      ...section.dataset,
      ...options,
    };

    this.section = section;

    this.performRecentlyViewedStorage();

    this.buildRecentlyViewed();
  }

  performRecentlyViewedStorage() {
    if (!this.options.productHandle || !window.localStorage) {
      return;
    }

    const productHandles = window.localStorage.getItem(
      this.options.localStorageKey,
    );

    if (productHandles) {
      this.productHandles = productHandles.split(',');

      const isCurrentHandleInRecentViewed = this.productHandles.find(
        handle => this.options.productHandle === handle,
      );

      if (!isCurrentHandleInRecentViewed) {
        if (this.productHandles.length > +this.options.limit) {
          this.productHandles.shift();
        }

        this.productHandles.push(this.options.productHandle);

        window.localStorage.setItem(
          this.options.localStorageKey,
          this.productHandles.join(','),
        );
      }
    } else {
      this.productHandles = [this.options.productHandle];

      window.localStorage.setItem(
        this.options.localStorageKey,
        this.options.productHandle,
      );
    }
  }

  buildRecentlyViewed() {
    if (!this.productHandles.length) {
      return;
    }

    const productHandlesNoCurrentProduct = this.productHandles.filter(
      handle => this.options.productHandle !== handle,
    );

    if (!productHandlesNoCurrentProduct.length) {
      return;
    }

    fetch(
      `/search?type=product&q=${productHandlesNoCurrentProduct.join(
        ',',
      )}&section_id=${this.options.localStorageKey}`,
    )
      .then(response => response.text())
      .then(response => {
        this.drawRecentlyViewed(response);
      });
  }

  drawRecentlyViewed(response: string) {
    if (!response) {
      return;
    }

    const domParser = new DOMParser();
    const responseHTML = domParser.parseFromString(response, 'text/html');
    const content = responseHTML.querySelector(this.options.selector);

    if (this.section && content) {
      this.section.innerHTML = content.innerHTML;

      this.initSlider();
    }
  }

  initSlider() {
    if (
      !this.section ||
      !this.section.querySelector(this.options.glideSelector)
    ) {
      return;
    }

    this.glide = new Glide(
      `${this.options.selector} ${this.options.glideSelector}`,
      this.options.sliderSettings,
    ).mount({Breakpoints});
  }
}
